/**
 * ID 매핑 헬퍼 함수
 * Feature 326: 오프라인 → 서버 ID 변환
 */

import { getRecord, putRecord, getAllRecords, STORES } from "./index";
import type { IdMapping } from "./types";

/**
 * ID 매핑 저장
 */
export async function saveIdMapping(mapping: Omit<IdMapping, "mappedAt">): Promise<void> {
  const data: IdMapping = {
    ...mapping,
    mappedAt: Date.now(),
  };
  await putRecord(STORES.ID_MAPPING, data);
}

/**
 * ID 매핑 조회
 */
export async function getIdMapping(localId: string): Promise<IdMapping | null> {
  const result = await getRecord<IdMapping>(STORES.ID_MAPPING, localId);
  return result ?? null;
}

/**
 * 로컬 ID를 서버 ID로 변환 (매핑이 없으면 원본 반환)
 */
export async function resolveServerId(localId: string): Promise<string> {
  if (!localId.startsWith("offline-")) {
    return localId; // 이미 서버 ID
  }
  const mapping = await getIdMapping(localId);
  return mapping?.serverId ?? localId;
}

/**
 * 모든 ID 매핑 조회 (디버깅용)
 */
export async function getAllIdMappings(): Promise<IdMapping[]> {
  return await getAllRecords<IdMapping>(STORES.ID_MAPPING);
}
